<div class="chart-container">
    <ng-template #loading>
      <div class="loading-container">
        <section class="loading-filters" style="margin: auto">
          <div  class="pulsing">
            <mat-spinner [diameter]="50" ></mat-spinner>
          </div>
          <p class="pulsing">{{"Loading" | translate }}</p>
        </section>
     
      </div>
    </ng-template>
      <div class="chart-container" *ngIf="graphAndFilters$ | async as graphAndFilters ; else loading">
        <div class="col-lg-9 mt-5">
          <a class="title" (click)="expandCollapseChart(!isExpanded)">
            <i class="bi bi-chevron-left"></i> {{ "AppointmentsByTypeOfService" | translate }}
          </a>
        </div>
        <div class="col-lg-6 mat-slide-toggle" *ngIf="helperService.user.role.roleId === 3">
          <mat-slide-toggle labelPosition="before" [(ngModel)]="ToggleAdvisor" (ngModelChange)="graphicByRole()">
            {{ "Advisor" | translate }}
          </mat-slide-toggle>
        </div>
        <div class="col-lg-6 mat-slide-toggle-hidden" *ngIf="helperService.user.role.roleId === 4">
          <mat-slide-toggle labelPosition="before">
            {{ "Advisor" | translate }}
          </mat-slide-toggle>
        </div>
        
        <div class="col-lg-6 chart-dropdown">
          <mat-form-field class="marcas">
            <mat-label class="tlmarcas"> {{"Make" | translate}} </mat-label>
            <mat-select [(ngModel)]="make">
              <mat-option *ngFor="let makes of graphAndFilters[1].makes"
              [value]="makes.make"
                (click)="graphicByRole()"
              >
                {{ makes.makeName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Sucursales -->
          <mat-form-field class="marcas">
            <mat-label class="tlmarcas"> {{ "Location" | translate }} </mat-label>
            <mat-select [(ngModel)]="locationId">
              <mat-option *ngFor="let locations of graphAndFilters[1].locations"
                [value]="locations.locationId"
                (click)="graphicByRole()"
              >
                {{ locations.locationName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!--LAPSOS DE TIEMPO-->
            <mat-form-field class="marcas">
              <mat-label class="tlmarcas"> </mat-label>
              <mat-select [(ngModel)]="selectDropdown">
                <mat-option *ngFor="let time of dropdownList" [value]="time" (click)="graphicByRole()">
                  {{ time | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </div>
        <ngx-charts-bar-vertical-stacked
        [scheme]="colorScheme"
        [results]="graphDashboard$ | async"
        [gradient]="false"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="true"
        [legendTitle]="''"
        [animations]="true"
        [legendPosition]="legendPosition"
        [barPadding]="50"
    >
    </ngx-charts-bar-vertical-stacked>
    </div>
</div>